import { WorkOrderProductsState } from "../types/work-order-products.interface";
import { createWorkOrderProductsState } from "../types/work-order-products.functions";

import {
  WorkOrderProductsActions,
  WorkOrderProductsActionType,
} from "./work-order-products.actions";

export function workOrderProductsReducer(
  state = createWorkOrderProductsState(),
  action: WorkOrderProductsActionType
): WorkOrderProductsState {
  switch (action.type) {
    case WorkOrderProductsActions.FetchProducts:
      return {
        ...state,
        errors: null,
        loading: true,
        products: [],
      };

    case WorkOrderProductsActions.AddProductFailure:
    case WorkOrderProductsActions.FetchProductsFailure:
    case WorkOrderProductsActions.UpdateProductsFailure:
      return {
        ...state,
        errors: action.payload,
        loading: false,
      };

    case WorkOrderProductsActions.AddProductSuccess:
      return {
        ...state,
        loading: false,
        products: [action.payload].concat(state.products),
      };

    case WorkOrderProductsActions.FetchProductsSuccess:
    case WorkOrderProductsActions.UpdateProductsSuccess:
      return {
        ...state,
        loading: false,
        products: action.payload,
      };

    case WorkOrderProductsActions.Reset:
      return createWorkOrderProductsState();

    default:
      return state;
  }
}
